import { render } from "./PlansListView.vue?vue&type=template&id=3c08ebbc"
import script from "./PlansListView.vue?vue&type=script&lang=js"
export * from "./PlansListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__